function setStatusColor(status){
    let color = "info";
    switch(status){
      case 0:
        color = "info";
        break;
      case 1:
        color = "warning";
        break;
      case 2:
      color = "danger";
      break;
    }
    return color;
  }
  export default setStatusColor